import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root',
})
export class CammsTranslateService {
    private httpClient = inject(HttpClient);

    private loaded = new Set<string>();

    loadResources(modules: string[], isAuthModule: boolean = false) {
        if(isAuthModule){
           return this.httpClient.get<Record<string, string>>(
            `./assets/i18n/en.json`
        ); 
        }
        return this.httpClient.get<Record<string, string>>(
            `${environment.baseUrl}/api/${environment.defaultApiVersion}/Localization/GetAllResourcesByLocalizationModules?LocalizationModules=${modules.join(',')}`
        );
    }

    isLoaded(lang: string, modules: string[]) {
        return this.loaded.has(`${lang}:${modules.sort().join(',')}`);
    }

    markLoaded(lang: string, modules: string[]) {
        this.loaded.add(`${lang}:${modules.sort().join(',')}`);
    }

    clearCache(){
        this.loaded.clear();
    }
}
